<template>
  <v-card>
    <validation-observer ref="mkoFormObs">
      <div class="row pa-2">
        <v-col cols="12" sm="6" class="pb-0" md="2">
          <custom-select
              :disabled="step>1"
              v-model="mko_id"
              rules="required"
              label="МКО"
              @input="onSelectMko"
              :items="mkos"
              vid="mko_id"
              name="МКО"
          ></custom-select>
        </v-col>
        <v-col cols="12" sm="6" class="pb-0" md="2">
          <custom-select
              :disabled="step>1"
              v-model="allData.worker_id"
              rules="required"
              label="Сотрудник"
              :items="workers"
              vid="worker_id"
          ></custom-select>
        </v-col>
        <v-col cols="12" sm="6" class="pb-0" md="2" v-if="step>0">
          <custom-input-text
              :disabled="!isSelectedMko"
              label="Серия паспорта или ФИО"
              @input="searchUser"
          ></custom-input-text>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <custom-select
              v-if="step>0"
              :disabled="!isSelectedMko"
              item-text="full_name"
              item-value="user_id"
              @input="setUserData"
              v-model="user_id"
              :items="users"
              label="Пользователь"
          ></custom-select>
        </v-col>
      </div>
    </validation-observer>
    <v-card-text>
      <v-stepper class="elevation-0" v-model="step">
        <div class="ux-step-header">
          <div :class="[
            'ux-step-header-item',
            {'ux-step-header-item-active': step > STEPS.start},
            {'ux-step-header-item-current': step >= STEPS.start},
            ]">
            <div class="ux-step-header-round cursor-pointer" @click="changeStepHandler(STEPS.start)">
              <v-icon dark>fas fa-check-square</v-icon>
            </div>
          </div>
          <div :class="[
            'ux-step-header-item',
            {'ux-step-header-item-active': step > STEPS.credit},
            {'ux-step-header-item-current': step >= STEPS.credit},
            ]">
            <div class="ux-step-header-round cursor-pointer" @click="changeStepHandler(STEPS.credit)">
              <v-icon dark>fas fa-credit-card</v-icon>
            </div>
          </div>
          <div :class="[
            'ux-step-header-item',
            {'ux-step-header-item-active': step > STEPS.user},
            {'ux-step-header-item-current': step >= STEPS.user},
            ]">
            <div class="ux-step-header-round cursor-pointer" @click="changeStepHandler(STEPS.user)">
              <v-icon dark>fas fa-user</v-icon>
            </div>
          </div>
          <div :class="[
            'ux-step-header-item',
            {'ux-step-header-item-active': step > STEPS.scoring},
            {'ux-step-header-item-current': step >= STEPS.scoring},
            ]">
            <div class="ux-step-header-round cursor-pointer">
              <v-icon dark>fas fa-window-restore</v-icon>
            </div>
          </div>
        </div>
        <v-stepper-items>
          <v-stepper-content :step="STEPS.start">
            <credit-start-step
                :has-available-workers="!isSelectedMko || !!workers.length"
                :disabled="!isSelectedMko ||!workers.length|| !isSelectedWorker"
                v-model="allData.payment_type"
                @apply="step = STEPS.credit"
            />
          </v-stepper-content>
          <v-stepper-content :step="STEPS.credit">
            <first-step
                :isCardTypeUzcard="isCardTypeUzcard"
                :cards="cards"
                :payment_type="allData.payment_type"
                :mko_id="mko_id"
                :worker_id="allData.worker_id"
                :tariffs="tariffs"
                :mkos="mkos"
                @exception:mko_id="message =>  $refs.mkoFormObs.setErrors({mko_id:[message] })"
                :user_id="user_id"
                @apply="gotoSecondStep"></first-step>
          </v-stepper-content>
          <v-stepper-content :step="STEPS.user">
            <second-step
                ref="userStep"
                :regions="regions"
                :formData="userData"
                :phone="allData.phone"
                :user_id="user_id"
                :mko_id="mko_id"
                @getDigIdInfo="getDigIdInfo"
                @apply="openInfoDialogHandler"></second-step>
          </v-stepper-content>
          <v-stepper-content :step="STEPS.scoring">
            <third-step :credit_id="credit_id"
                        :phone="allData.phone"
                        :user_card_id="allData.user_card_id"
                        :amount="allData.amount"
                        :initial="allData.initial_payment"
                        :firstPayment="firstPayment"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
    <info-dialog :user_id="user_id" @apply="gotoThirdStep" :data="allData" v-model="infoDialog"></info-dialog>
  </v-card>
</template>

<script>
import firstStep from "@/components/credit/firstStep";
import secondStep from "@/components/credit/secondStep";
import thirdStep from "@/components/credit/thirdStep";
import infoDialog from "@/components/credit/infoDialog";
import {debounce} from "@/utils/pureFunctions";
import CreditStartStep from '@/components/credit/StartStep'
import {DATE_FORMAT, GENDERS, parsePhone} from "@/utils/constants";
import moment from 'moment'

const DEFAULT_ALL_DATA = {
  first_name: null,
  last_name: null,
  middle_name: null,
  gender: null,
  region_id: null,
  district_id: null,
  birth_day: null,
  birth_address: null,
  inn: null,
  pnfl: null,
  phone: null,
  phones: [],
  passport_address: null,
  live_address: null,
  address_mfy: null,
  passport_series: null,
  passport_number: null,
  passport_issue_date: null,
  passport_expiry_date: null,
  passport_photo: null,

  user_card_id: null,
  mko_id: null,
  mko_tariff_id: null,
  amount: null,
  period: null,
  payment_date: null,
  details: null,
  turn_autopayment: true,
  initial_payment: null,
  worker_id: null,
  payment_type: null,
  comment: null,
  work_place: null,
  position: null
}
const DEFAULT_USER_DATA = {
  first_name: null,
  last_name: null,
  middle_name: null,
  gender: null,
  region_id: null,
  district_id: null,
  birth_day: null,
  birth_address: null,
  inn: null,
  pnfl: null,
  phone: null,
  phones: [],
  passport_address: null,
  live_address: null,
  address_mfy: null,
  passport_series: null,
  passport_number: null,
  passport_issue_date: null,
  passport_expiry_date: null,
  passport_photo: null,
}

const STEPS = {
  start: 0,
  credit: 1,
  user: 2,
  scoring: 3
}

export default {
  data() {
    return {
      isCardTypeUzcard: false,
      workers: [],
      infoDialog: false,
      mko_id: null,
      user_id: null,
      credit_id: null,
      step: STEPS.start,
      regions: [],
      districts: [],
      tariffs: [],
      mkos: [],
      users: [],
      cards: [],
      firstPayment: null,
      userData: {
        ...DEFAULT_USER_DATA
      },
      allData: {
        ...DEFAULT_ALL_DATA
      },
      STEPS
    }
  },
  methods: {
    async onSelectMko(mko_id) {
      if (mko_id) {
        try {
          this.workers = await this.$store.dispatch('getWorkers', {mko_id})
          const selectedMko = this.mkos.find(item => item.id === mko_id)
          if(selectedMko) this.isCardTypeUzcard = selectedMko.has_my_uzcard
          this.allData.worker_id = null
        } catch (e) {
          this.$setResponseError({error: e})
        }
      }
    },
    clearAllUserData() {
      const allData = {...this.allData}
      Object.keys(DEFAULT_USER_DATA).forEach(item => {
        allData[item] = DEFAULT_USER_DATA[item]
      })
      this.allData = allData
    },
    async getDigIdInfo() {
      const {userStep} = this.$refs
      this.clearAllUserData()
      this.$showLoading()
      try {
        let params = {
          mko_id: this.mko_id,
          passport_serial: this.userData.passport_series,
          passport_number: this.userData.passport_number,
          pinfl: this.userData.pnfl
        }
        const {data: data} = await this.$http.get('admin/users/get-info-digid',{params})
        let userData = data.data.user_info
        userData.middle_name = userData.mid_name
        if(data.data.id) {
          if (data.data.phone) {
            userData.phone = parsePhone(data.data.phone).format('min')
          }

          if (data.data.user_info.phones) {
            userData.phones = JSON.parse(data.data.user_info.phones).map(item => parsePhone(item).format('min'))
          } else {
            userData.phones = []
          }

          delete userData['updated_at']
          delete userData['id']
          delete userData['created_at']
          // delete userData['passport_photo']
          userData['birth_day'] = moment(userData['birth_day']).format(DATE_FORMAT)
          this.cards = [...data.data.user_cards]
        }

        this.userData = userData
        if (data.data.user_info.region_id) {
          await userStep.getDistrict(data.data.user_info.region_id, true)
        }
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()

      }
    },
    async setUserData(id) {
      const {userStep} = this.$refs
      this.clearAllUserData()
      this.$showLoading()
      try {
        const {data: {data: {user_info, user_cards, phone}}} = await this.$http.get(`admin/users/info/${id}`)
        let userData = {...user_info}
        userData.middle_name = userData.mid_name
        if (phone) {
          userData.phone = parsePhone(phone).format('min')
        }

        if (user_info.phones) {
          userData.phones = JSON.parse(user_info.phones).map(item => parsePhone(item).format('min'))
        } else {
          userData.phones = []
        }
        delete userData['updated_at']
        delete userData['id']
        delete userData['created_at']
        // delete userData['passport_photo']
        userData['birth_day'] = moment(userData['birth_day']).format(DATE_FORMAT)
        this.userData = userData
        this.cards = [...user_cards]
        if (user_info.region_id) {
          await userStep.getDistrict(user_info.region_id, true)
        }
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()

      }
    },
    async gotoThirdStep() {
      const {
        first_name,
        last_name,
        middle_name,
        gender,
        region_id,
        district_id,
        birth_day,
        birth_address,
        inn,
        pnfl,
        phone,
        passport_address,
        live_address,
        address_mfy,
        passport_series,
        passport_number,
        passport_photo,
        passport_issue_date,
        passport_expiry_date,
        user_card_id,
        mko_id,
        mko_tariff_id,
        amount,
        period,
        payment_type,
        payment_date,
        details,
        turn_autopayment,
        initial_payment,
        phones,
        worker_id,
        comment,
        work_place,
        position
      } = this.allData

      const formData = {
        first_name,
        last_name,
        middle_name,
        gender,
        region_id,
        district_id,
        birth_day,
        birth_address,
        inn,
        pnfl,
        phone,
        phones,
        passport_address,
        live_address,
        address_mfy,
        passport_series,
        passport_number,
        passport_photo,
        passport_issue_date,
        passport_expiry_date,
        user_card_id,
        mko_id,
        mko_tariff_id,
        amount,
        period,
        payment_type,
        payment_date,
        details,
        turn_autopayment,
        initial_payment,
        worker_id,
        comment,
        work_place,
        position
      }
      if (this.user_id) formData.user_id = this.user_id
      try {
        this.$showLoading()
        const {data: {data}} = await this.$http.post('admin/credits/create/step-third', formData)
        this.credit_id = data.id
        this.infoDialog = false
        this.step = STEPS.scoring
        if(data.first_payment)
          this.firstPayment = data.first_payment;
        this.$clearLoading()
      } catch (e) {
        this.$setResponseError({error: e})
        this.$clearLoading()
      }
    },
    gotoSecondStep(data) {
      if (this.mko_id && this.allData.worker_id) {
        this.step = STEPS.user
        if (data.phone) this.userData.phone = data.phone
        this.allData = {...this.allData, ...data}
      } else {
        if (!this.mko_id) {
          this.$refs['mkoFormObs'].setErrors({
            mko_id: ["Mko поле обязательно для заполнения"]
          })
        }
        if (this.allData.worker_id) {
          this.$refs['mkoFormObs'].setErrors({
            worker_id: ["Сотрудник поле обязательно для заполнения"]
          })
        }
      }
    },
    openInfoDialogHandler(data) {
      this.allData = {...this.allData, ...data}
      this.infoDialog = true
    },
    searchUser: debounce(async function (search) {
      if (search.length > 1) {
        const params = {
          search,
          mko_id: this.mko_id
        }
        this.$showLoading()
        try {
          const {data: {data}} = await this.$http.get('admin/users/search', {params})
          this.users = data
        } catch (e) {
          this.$setResponseError({error: e})
        } finally {
          this.$clearLoading()
        }
      }
    }, 350),
    changeStepHandler(step) {
      if (step < this.step) {
        this.step = step
      }
    },
  },
  computed: {
    isSelectedMko() {
      return !!this.mko_id
    },
    isSelectedWorker() {
      return !!this.allData.worker_id
    },
    isPaymentTypeCard() {
      return this.allData.payment_type === 'card'
    },
    isSelectedUser() {
      return !!this.user_id
    }
  },
  components: {firstStep, secondStep, thirdStep, infoDialog, CreditStartStep},
  async created() {
    this.$showLoading()
    try {
      this.regions = await this.$store.dispatch('getRegions')
      this.tariffs = await this.$store.dispatch('getTariffs')
      this.mkos = await this.$store.dispatch('getMkos')
    } catch (e) {
      this.$setResponseError({error: e})
    }
    this.$clearLoading()
  }
}
</script>
